<template>
  <a-modal
    title="请选择租户"
    :width="450"
    :visible="visible"
    :closable="false"
    :maskClosable="false"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form>
      <a-form-item :labelCol="{ span: 4 }" :wrapperCol="{ span: 20 }" style="margin-bottom: 10px">
        <a-tooltip placement="topLeft">
          <template slot="title">
            <span>您有多个租户，请选择登录租户</span>
          </template>
          <a-avatar style="backgroundcolor: #87d068" icon="gold" />
        </a-tooltip>

        <a-select
          @change="handleTenantChange"
          placeholder="请选择登录租户"
          style="margin-left: 10px; width: 80%"
          v-model:value="tenant_id"
        >
          <a-icon slot="suffixIcon" type="gold" />
          <a-select-option v-for="d in tenantList" :key="d.id" :value="d.id">
            {{ d.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import Vue from 'vue'
import { getAction } from '@/api/manage'
import { TENANT_ID, USER_INFO } from '@/store/mutation-types'

export default {
  name: 'TenendSelect',
  data() {
    return {
      visible: false,
      tenantList: [],
      tenant_id: '',
    }
  },
  methods: {
    show() {
      this.tenantList = []

      this.tenant_id = Number(Vue.ls.get(TENANT_ID))
      let user = Vue.ls.get(USER_INFO)
      let ids = user.relTenantIds
      getAction('/sys/tenant/queryList', { ids: ids }).then((res) => {
        this.tenantList = res.result
        this.visible = true
      })
    },
    handleOk() {
      this.visible = false
      this.$store.dispatch('saveTenant', this.tenant_id)

      this.$notification.success({
        message: '切换租户',
        description: `租户切换成功`,
      })
      // location.reload();
    },
    handleCancel() {
      this.visible = false
    },
    handleTenantChange(e) {
      this.tenant_id = e
    },
  },
}
</script>

<style scoped></style>
